import {
    BooleanInput,
    DeleteButton,
    SaveButton,
    TabbedForm,
    TextInput,
    Toolbar,
    required,
    useRecordContext,
    useSaveContext,
} from "react-admin";
import { useFormState } from "react-hook-form";
import { Company } from "../../../shared/types/types";
import { Grid, Box } from "@mui/material";

import image1 from "./image1.jpg";

import BarTreeView from "../../../shared/components/treeview/BarTreeView";
import CharacterNormativeList from "../../../shared/components/character-normative/CharacterNormative";

const NormativeCustomToolbar = ({ record }: { record: any }) => {
    const saveContext = useSaveContext();
    const { isSubmitting } = useFormState();
    const isSaving = Boolean(isSubmitting || saveContext?.saving);

    return (
        <Toolbar>
            <SaveButton
                type="button"
                disabled={isSaving}
                label={isSaving ? "Guardando..." : "ra.action.save"}
                transform={data => ({ ...record, ...data })}
            />
            <DeleteButton mutationMode="pessimistic" />
        </Toolbar>
    );
};

const NormativeForm = () => {
    const record = useRecordContext<Company>();

    return (
        <TabbedForm
            toolbar={false}
            defaultValues={{ id: "0000-0000-0000-0000" }}
        >
            <TabbedForm.Tab label="resources.normative.title">
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <TextInput
                            source="code"
                            label="resources.normative.fields.code"
                            fullWidth
                            validate={required()}
                        />
                        <TextInput
                            source="name"
                            label="resources.normative.fields.name"
                            fullWidth
                            validate={required()}
                        />
                        <TextInput
                            source="description"
                            label="resources.normative.fields.description"
                            fullWidth
                            validate={required()}
                        />
                        <BooleanInput
                            source="active"
                            label="resources.normative.fields.active"
                        />

                        <BooleanInput
                            source="operative"
                            label="resources.normative.fields.isrecord"
                        />
                        <NormativeCustomToolbar record={record} />
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                borderRadius: 2,
                                height: "500px",
                                backgroundColor: "primary.main",
                            }}
                        >
                            <Box
                                component="img"
                                src={image1}
                                alt=""
                                sx={{
                                    borderRadius: "inherit",
                                    width: "100%",
                                    height: "inherit",
                                    objectPosition: "center",
                                    objectFit: "cover",
                                    opacity: "0.5",
                                }}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </TabbedForm.Tab>

            {record && (
                <TabbedForm.Tab label="resources.normative.structure">
                    <BarTreeView />
                </TabbedForm.Tab>
            )}
        </TabbedForm>
    );
};

export default NormativeForm;
